import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark} from "@/shared/Constants";

export const HoroscopeListContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-top: 1px solid ${Color.greySeparator};
  margin-top: 5px;
  ${breakpoints.darkMode} {
    [data-theme='dark'] & {
    border-top:1px solid ${ColorDark.greySeparator};
    }
  }
  .horoscope-predictions-list-header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 10px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      border-bottom: 1px solid ${ColorDark.greySeparator};
      }
    }
    .horoscope-predictions-list-header-text {
      margin-top: 16px;
      ${Font.sansBold};
      color: ${Color.black000};
      font-size: 20px;
      line-height: 19px;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color:  ${ColorDark.textLight};
        }
      }
      ${breakpoints.phone} {
        font-size: 18px;
      }
    }
  }
  .horoscope-predictions-list-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-bottom: 1px solid ${Color.greySeparator};
    margin-top: 45px;
    padding-bottom: 45px;
    gap: 5px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      border-bottom:1px solid ${ColorDark.greySeparator};
      }
    }
    ${breakpoints.phone} {
      align-items: flex-start;
    }
    .horoscope-predictions-list-item-date {
      text-align: center;
      ${Font.sansSemiBold};
      font-size: 16px;
      line-height: 19px;
      color: ${Color.black000};
      
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color:  ${ColorDark.textLight};
        }
      }
      ${breakpoints.phone} {
        text-align: left;
      }
    }
    .horoscope-predictions-list-item-text {
      width: 60%;
      text-align: center;
      ${Font.clarinVarSub2Regular};
      font-size: 23px;
      line-height: 33px;
      color: ${Color.black000};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color:  ${ColorDark.textLight};
        }
      }
      ${breakpoints.phone} {
        text-align: left;
        width: 95%;
        font-size: 21px;
        line-height: 30px;
      }
    }
  }
`;
